import { Avatar } from '@loomhq/lens';
import React from 'react';

const DefaultAvatar = ({ color = 'currentColor', ...props }) => (
  <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" {...props}>
    <circle opacity={0.2} cx={20} cy={20} r={20} fill={color} />
    <path d="M10.476 29.889a9.524 9.524 0 0119.047 0H10.476z" fill={color} />
    <circle
      cx={20.001}
      cy={13.222}
      transform="rotate(-90 20 13.222)"
      fill={color}
      r={5.556}
    />
  </svg>
);

const UserAvatar = ({ name, avatarSrc, avatarSize, ...props }) => {
  if (avatarSrc) {
    return <Avatar size={avatarSize} imageSrc={avatarSrc} {...props} />;
  }

  if (name) {
    const avatarLetter = name.charAt(0);

    return <Avatar size={avatarSize} letter={avatarLetter} {...props} />;
  }

  return (
    <Avatar size={avatarSize} {...props}>
      <DefaultAvatar />
    </Avatar>
  );
};

export default UserAvatar;
